import { Badge } from "@/components/badge";

import { LockIcon } from "./icons/LockIcon";
import { MessageChatCircleIcon } from "./icons/MessageChatCircleIcon";

interface CreatorTagBadgeProps {
  readonly isCustomerNote: boolean;
}

export function CreatorTagBadge({ isCustomerNote }: CreatorTagBadgeProps) {
  if (isCustomerNote) {
    return (
      <Badge
        className="bg-[#ECFDF3] border-[#ABEFC6] text-[#067647]"
        isRounded
        size="large"
        variant="success"
      >
        <MessageChatCircleIcon />
        Customer insight
      </Badge>
    );
  }

  return (
    <Badge
      className="bg-bg-primary border-[#D5D9EB] text-text-secondary"
      isRounded
      size="large"
    >
      <LockIcon />
      Internal
    </Badge>
  );
}
